// extracted by mini-css-extract-plugin
export var askAiIcon = "_jx-9";
export var container = "_jx-0";
export var groupSeparator = "_jx-a";
export var highlight = "_jx-4";
export var resultIcon = "_jx-5";
export var resultItem = "_jx-7";
export var resultSubtitle = "_jx-3";
export var resultTitle = "_jx-2";
export var resultsList = "_jx-1";
export var searchGroup = "_jx-6";
export var selected = "_jx-8";